import React from 'react';
import Truncate from 'react-truncate';
import classNames from 'classnames';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import { NodeEvent } from '../../../../types/uncinc_profile/nodes';
import { dateFormatter } from '../../../../helpers';

interface NodeEventTeaserProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<NodeEvent>;
  classes: string;
}

const NodeEventTeaser: React.FC<NodeEventTeaserProps> = ({ entity, classes, ...props }) => {
  const node = entity.toJS();
  const title = node.title[0].value;
  const lang = node.langcode[0]?.value;

  return (
    <div className={classNames('NodeEventTeaser', classes)} {...props}>
      <div className="NodeEventTeaser__info">
        <div className="NodeEventTeaser__date" />
        {dateFormatter(node.created[0]?.value, lang)}
      </div>
      <div className="NodeEventTeaser__content">
        <h3 className="NodeEventTeaser__heading">
          <Truncate lines={2} ellipsis="...">
            {title}
          </Truncate>
        </h3>
        <Truncate lines={3}>
          <WysiwygField
            html={node.body[0]?.summary}
            className="NodeEventTeaser__body"
          />
        </Truncate>
      </div>
    </div>
  );
};

export default NodeEventTeaser;
